module.exports = __webpack_public_path__ + "a7291dc6.svg";